import { useEffect, useState } from 'react';
import useLocalStorage from './useLocalStorage';
import { useAppState } from '../contexts/appState';
import { getContractType } from '../api';
import { handleValidatorPopup, handleSetCsPortalData } from '../reducersAndActions/actions/appStateActions';
import { freeExpiredContractType, paidContractType } from '../lib/common';
import { useAuth } from '../contexts/auth';

function useContractTypeValidator(currentComponentType = 'paid') {
  const [appState, appDispatch] = useAppState();
  const [authState] = useAuth();
  const { allBusinesses, sidResponse } = authState;
  const [selectedBusiness, setSelectedBusiness] = useState({});
  const queryParams = new URLSearchParams(window.location.search);
  const queryDocId = queryParams.get('docid');
  const [, setSelectedBusinessLocal] = useLocalStorage('selectedBusiness', {});
  const [isProperContractType, setIsProperContractType] = useState(true);
  const [contractTypeVal, setContractTypeVal] = useState('');

  const openLoginPopUp = (msg, login = false) => {
    handleValidatorPopup(appDispatch, {
      ...appState.validatorPopup,
      open: true,
      individual: true,
      redirect: !login,
      desc: msg || 'Please login to access this page!',
      login,
    });
  };

  const handleIsContractTypeMatch = (currentContractType) => {
    if (currentComponentType === 'free') {
      return freeExpiredContractType.includes(currentContractType);
    }
    return paidContractType.includes(currentContractType);
  };

  const handleLoginPopupDiffContract = () => {
    openLoginPopUp(
      "It looks like you've logged in with different mobile number, please login with your required registered mobile number.",
      true,
    );
  };

  const validator = () => {
    if (!sidResponse) {
      openLoginPopUp('', true);
      setIsProperContractType(false);
    } else if (allBusinesses?.length > 0 && queryDocId) {
      let businessFound = false;
      allBusinesses.forEach((business) => {
        if (business?.docid === queryDocId) {
          businessFound = true;
          setSelectedBusiness(business);
        }
      });
      if (!businessFound) {
        handleLoginPopupDiffContract();
      }
    } else {
      handleLoginPopupDiffContract();
      setIsProperContractType(false);
    }
  };

  useEffect(() => {
    const handleSelectedBusiness = async () => {
      if (selectedBusiness && selectedBusiness.docid) {
        setSelectedBusinessLocal(selectedBusiness);
        handleSetCsPortalData(appDispatch, {
          csportalData: { type: 'business', docId: selectedBusiness?.docid || '' },
        });
        const contractTypeRes = await getContractType(selectedBusiness.parentid, selectedBusiness.data_city);
        sessionStorage.setItem('contractType', JSON.stringify(contractTypeRes?.result || ''));
        setContractTypeVal(contractTypeRes?.result);
        if (!handleIsContractTypeMatch(contractTypeRes.result)) {
          openLoginPopUp(`You can't access this page. Looks like your contract has expired`, false);
          setIsProperContractType(false);
          return;
        }

        if (freeExpiredContractType.includes(contractTypeRes.result)) {
          const errMsg =
            contractTypeRes.result === 'expiredLong'
              ? 'Your paid listing has expired, please update your listing!'
              : 'Your need a paid listing to access this page!';
          openLoginPopUp(errMsg);
          setIsProperContractType(false);
          return;
        }
        setIsProperContractType(true);
      }
    };
    handleSelectedBusiness();
  }, [selectedBusiness, allBusinesses]);

  return [isProperContractType, validator, contractTypeVal];
}

export default useContractTypeValidator;
